module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAANlBMVEX//v7////TQk1qv5MAkkbOKzcAfyXJFyT+/PzTQk1qv5P///8AkkbOKzcAfyXJFyRqv5PTQk2tHvfcAAAAC3RSTlPz+fPx8fHx8efm5KV9rJoAAABgSURBVHhe7do3EcBADABBOefEn6wJyMU3Py72CCyBiz5vXKOweZmGvNjzznsr7bmOvE+jawqJaP9iMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDEaN/6rGR/YCcfutZ37c6TQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Italy.png
// module id = 583
// module chunks = 0